<template>
  <div class="container">
    <nav class="navbar navbar-expand-lg bg-body-tertiary mb-5 container-md">
      <div class="container-fluid">
        <router-link class="nav-link" to="/">
          <img class="nav-logo" src="@/assets/images/linkcurt_fondo_transparente.png" alt="LinkCurt Logo">
        </router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">

            <li class="nav-item" v-if="hasUserData">
              <router-link
                  class="nav-link"
                  :class="{ 'fw-bold': isActive('/create-link') }"
                  to="/create-link"
              >Create short link
              </router-link>
            </li>

            <li class="nav-item" v-if="hasUserData">
              <router-link
                  class="nav-link"
                  :class="{ 'fw-bold': isActive('/links') }"
                  to="/links"
              >Short links
              </router-link>
            </li>
            <li class="nav-item" v-if="hasUserData">
              <router-link
                  class="nav-link"
                  :class="{ 'fw-bold': isActive('/Statistics') }"
                  to="/Statistics"
              >User statistics
              </router-link>
            </li>
            <li
                class="nav-item dropdown" v-if="isAdmin"
                :class="{ 'fw-bold': isActive('/adminlinks') || isActive('/adminStatistics')}"
            >
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                 aria-expanded="false">
                Admin
              </a>
              <ul class="dropdown-menu">
                <li class="nav-item">
                  <router-link
                      class="nav-link"
                      :class="{ 'fw-bold': isActive('/adminlinks') }"
                      to="/adminlinks"
                  >All short links
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link
                      class="nav-link"
                      :class="{ 'fw-bold': isActive('/adminStatistics') }"
                      to="/adminStatistics"
                  >Admin statistics
                  </router-link>
                </li>
              </ul>
            </li>

          </ul>
          <div class="d-flex align-items-center gap-4" v-if="!hasUserData">
            <router-link
                class="nav-link"
                :class="{ 'fw-bold': isActive('/login') }"
                to="/login"
            >Login
            </router-link>
            <router-link
                class="nav-link"
                :class="{ 'fw-bold': isActive('/Subscribe') }"
                to="/register"
            >Register
            </router-link>
          </div>
          <div v-else class="d-flex align-items-center gap-4">
            <span class="nav-link fw-bold">Hello {{ name }}</span>
            <router-link
                class="nav-link"
                :class="{ 'fw-bold': isActive('/') }"
                to="/"
                @click.prevent="logout"
            >Logout
            </router-link>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import {eventBus} from '@/eventBus';
import {checkUserData, logout} from '@/services/auth/loginService.js';

export default {
  name: "HeadComponent",
  /**
   * Returns an object containing initial data properties.
   *
   * @return {Object} An object with the initial properties:
   * - hasUserData {boolean}: Indicates if user data is present.
   * - name {string}: Represents the name of the user.
   * - isAdmin {boolean}: Determines if the user has administrative privileges.
   */
  data() {
    return {
      hasUserData: false,
      name: '',
      isAdmin: false
    };
  },
  /**
   * Lifecycle hook executed after the component is mounted.
   * This method initializes the user data by invoking `updateUserData`.
   * It also sets up listeners for storage events and custom events to update user data dynamically.
   *
   * @return {void} Does not return any value.
   */
  mounted() {
    this.updateUserData();
    window.addEventListener('storage', this.updateUserData);
    eventBus.on('session-updated', this.updateUserData);
  },
  /**
   * Cleanup operations to be performed right before the component is unmounted.
   * Removes event listeners for 'storage' changes and custom 'session-updated' events.
   *
   * @return {void} Does not return any value.
   */
  beforeUnmount() {
    window.removeEventListener('storage', this.updateUserData);
    eventBus.off('session-updated', this.updateUserData);
  },
  /**
   * Methods object containing utility functions for managing user session data and route state.
   */
  methods: {
    /**
     * Updates the user data properties of the instance by retrieving information from sessionStorage.
     * This method checks if user data exists and updates the following properties:
     * - hasUserData: Indicates whether user data is available.
     * - name: Retrieves and assigns the user's name from sessionStorage, defaulting to an empty string if not found.
     * - isAdmin: Determines if the user has an admin role based on sessionStorage data.
     *
     * @return {void} Does not return a value. Updates instance properties directly.
     */
    updateUserData() {
      this.hasUserData = checkUserData();
      this.name = sessionStorage.getItem('name') || '';
      this.isAdmin = sessionStorage.getItem('role') === 'admin';
    },
    /**
     * Logs out the current user by performing the following actions:
     * - Executes the logout function.
     * - Removes the stored authentication token from session storage.
     * - Updates the user's data to reflect the logout state.
     * - Emits a 'session-updated' event through the event bus.
     *
     * @return {void} This method does not return a value.
     */
    logout() {
      logout();
      sessionStorage.removeItem('token');
      this.updateUserData();
      eventBus.emit('session-updated');
    },
    isActive(path) {
      return this.$route.path === path;
    }
  },
};
</script>

<style scoped>

.navbar {
  max-width: 50dvw;
}

.nav-logo {
  height: 90px; /* Adjust this value as needed */
  width: auto;
}

</style>
